import strings from "rivals/components/pages/Registration/strings";

export default {
  ...strings,
  createAnAccount: "CREATE AN ACCOUNT",
  passwordRequirements:
    "Password must be at least 9 characters and contain a number",
  usernameVisibleToOthers:
    "Username is visible to others when you post in the forums."
};
